export default class extends Controller {
  static targets = ["deleteButton", "inLibraryCheckbox"]

  connect() {
    App.Helpers.addAjaxSuccessHandler(this.deleteButtonTarget, this.removeSelf.bind(this))
  }

  setPrimary(event) {
    event.preventDefault()
    App.Helpers.ajaxRequest({
      url: event.currentTarget.href,
      method: "POST",
      successHandler: emitSetPrimarySuccessEvent.bind(this)
    })
  }

  openEditForm(event) {
    event.preventDefault()
    App.Helpers.ajaxRequest({
      url: event.currentTarget.href,
      successHandler: this.replaceWithContent.bind(this)
    })
  }

  replaceWithContent(response) {
    App.Helpers.replaceElement(this.element, response, true)
  }

  removeSelf() {
    this.element.remove()
  }

  toggleInLibrary(event) {
    if (this.blockInLibraryToggle) {
      this.blockInLibraryToggle = false
    } else {
      const url = event.currentTarget.dataset.updateUrl
      App.Helpers.ajaxRequest({ url, method: "POST", errorHandler: this.resetLibraryCheckbox })
    }
  }

  resetLibraryCheckbox() {
    this.blockInLibraryToggle = true
    this.isInLibrary = !this.isInLibrary
  }

  get isInLibrary() {
    return this.inLibraryCheckboxTarget.checked
  }

  set isInLibrary(val) {
    this.inLibraryCheckboxTarget.checked = val
  }
}



// WEBPACK FOOTER //
// ./app/components/assets/assets/javascript/assets-table-row-controller.js